import { DRAG_START } from '../../../../../../reducers/draggingConstants';
import { ELEMENT_CREATION_SOURCES } from '../../../../../../../common/elements/elementConstants';

const imagePopupStayActivePredicate = (state, action) => {
    if (action.type === DRAG_START && action.source === ELEMENT_CREATION_SOURCES.IMAGE_SEARCH) {
        return true;
    }

    return false;
};

export default imagePopupStayActivePredicate;
